module.exports = __webpack_public_path__ + "img/avataaars.9ec11a18.svg";